var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1913 0.0551758C4.98325 0.0551758 0.746094 4.29233 0.746094 9.50034C0.746094 14.7084 4.98325 18.9455 10.1913 18.9455C15.3993 18.9455 19.6364 14.7084 19.6364 9.50034C19.6364 4.29233 15.3993 0.0551758 10.1913 0.0551758ZM8.73816 12.4065C8.73816 12.5992 8.66161 12.784 8.52536 12.9203C8.3891 13.0566 8.2043 13.1331 8.01161 13.1331C7.81891 13.1331 7.63411 13.0566 7.49786 12.9203C7.3616 12.784 7.28506 12.5992 7.28506 12.4065V6.59414C7.28506 6.40144 7.3616 6.21664 7.49786 6.08039C7.63411 5.94413 7.81891 5.86759 8.01161 5.86759C8.2043 5.86759 8.3891 5.94413 8.52536 6.08039C8.66161 6.21664 8.73816 6.40144 8.73816 6.59414V12.4065ZM13.0975 12.4065C13.0975 12.5992 13.0209 12.784 12.8847 12.9203C12.7484 13.0566 12.5636 13.1331 12.3709 13.1331C12.1782 13.1331 11.9934 13.0566 11.8572 12.9203C11.7209 12.784 11.6444 12.5992 11.6444 12.4065V6.59414C11.6444 6.40144 11.7209 6.21664 11.8572 6.08039C11.9934 5.94413 12.1782 5.86759 12.3709 5.86759C12.5636 5.86759 12.7484 5.94413 12.8847 6.08039C13.0209 6.21664 13.0975 6.40144 13.0975 6.59414V12.4065Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.19542a8859e5c1746f6abdd517403786.svg";
export { ForwardRef as ReactComponent };